import { TerminatedTaskStatus, isSuccessTerminated } from '~/constants/task-status'
import { useTask } from '~/contexts/TaskContext'
import { AgentTaskStatus, CommandType, commandTypeFromJSON } from '~/protos/agents'
import { getEffectiveTaskStatus } from '~/task/commandTypeUtils'
import { useIsInternalUploadedIndex, useIsLocalSyncIndex } from '../organization'
import { useIsS3Task } from './useS3Task'
import { useTaskStatus } from './useTaskStatus'

export function useTerminatedStatus() {
  const status = useTaskStatus()
  const isS3Task = useIsS3Task()
  const isInternalUploadedIndex = useIsInternalUploadedIndex()
  const isLocalSyncIndex = useIsLocalSyncIndex()
  const { task } = useTask()
  const command = commandTypeFromJSON(task?.cmd_type)

  // Use getEffectiveTaskStatus (single source of truth) to handle
  // document-generating commands that treat DIFF_GENERATED/DRAFT_GENERATED as COMPLETED
  const effectiveStatus = getEffectiveTaskStatus(status, command)

  // Local tasks (S3, internal upload, local sync, mulesoft migration) also
  // treat DIFF_GENERATED/DRAFT_GENERATED as terminal independently of command type
  const isLocalTask =
    isS3Task ||
    isInternalUploadedIndex ||
    isLocalSyncIndex ||
    command === CommandType.MULESOFT_TO_CAMEL_MIGRATION
  const isLocalTaskTerminated =
    isLocalTask &&
    (status === AgentTaskStatus.DIFF_GENERATED || status === AgentTaskStatus.DRAFT_GENERATED)

  if (isLocalTaskTerminated || isSuccessTerminated(effectiveStatus)) {
    return true
  }
  return TerminatedTaskStatus.includes(effectiveStatus)
}
